"use strict";
export function queryWithoutCache(queryOptions) {
  return {
    ...queryOptions,
    gcTime: 0,
    staleTime: 0
  };
}
